import { styled, Box } from "@mui/material";

export const CamerasWrapperRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: "3rem",
  left: 0,
  right: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));
